import { GET_PROYECTS } from "./Actions/actionType";
import tresEstrellasArticulos from "../imagenes/tresEstrellas/Articulos.jpg";
import tresEstrellasClientes from "../imagenes/tresEstrellas/Clientes.jpg";
import tresEstrellasProv from "../imagenes/tresEstrellas/Prov.jpg";
import tresEstrellasResumen from "../imagenes/tresEstrellas/resumen.jpeg";
import tresEstrellasHome from "../imagenes/tresEstrellas/ScreenShot004.jpg";
import marventoScreen003 from "../imagenes/Marvento-WEB/ScreenShot003.jpg";
import marventoScreen004 from "../imagenes/Marvento-WEB/ScreenShot004.jpg";
import marventoScreen005 from "../imagenes/Marvento-WEB/ScreenShot005.jpg";
import inmoImg1 from '../imagenes/Inmobiliaria-WEB/ScreenShot003.jpg';
import inmoImg2 from '../imagenes/Inmobiliaria-WEB/ScreenShot004.jpg';
import inmoImg3 from '../imagenes/Inmobiliaria-WEB/ScreenShot005.jpg';

const initialState = {
    proyectos: [
        {
            titulo: 'Sistema Web Administrativo',
            descripcion: 'Sistema administrativo para una PyME de indumentaria deportiva. Incluye perfiles con permisos, clientes, proveedores, cuentas corrientes, remitos, ordenes de compra, articulos, informes y ajustes de stock.',
            tecnologiasUtilizadas: 'Frontend: HTML, CSS, Material UI, React, Redux, JavaScript, Vercel. Backend: Node, MongoDB, Express, JWT, NPM, Heroku.',
            linkGithubFront: 'https://github.com/fmarcos38/Front-Tres-Estrellas',
            linkGithubBack: 'https://github.com/fmarcos38/Back-Tres-Estrellas',
            imag1: tresEstrellasHome,
            imag2: tresEstrellasArticulos,
            imag3: tresEstrellasClientes,
            imag4: tresEstrellasProv,
            imag5: tresEstrellasResumen,
        },
        {
            titulo: 'Sistema Web Administrativo para distribuidora de frutos secos',
            descripcion: 'Sistema de gestion para productos, clientes, proveedores y gastos. Incluye CRUD, tablas con filtros, ordenamientos por fecha y login, vistas diferenciadas para administrador y cliente.',
            tecnologiasUtilizadas: 'Frontend: HTML, CSS, Material UI, React, Redux, JavaScript, Vercel. Backend: Node, MongoDB, Express, Cloudinary, JWT, NPM, Google Cloud.',
            linkGithubFront: 'https://github.com/fmarcos38/Especiera_del_sol_Frontend',
            linkGithubBack: 'https://github.com/fmarcos38/Especiera_del_sol_Backend',
            linkURL: 'https://front-especiera-sol-jjfi.vercel.app/',
            imag1: 'https://res.cloudinary.com/da655b7xh/image/upload/v1729596829/ScreenShot133_ansnb0.jpg',
            imag2: 'https://res.cloudinary.com/da655b7xh/image/upload/v1729596829/ScreenShot132_lzkzr8.jpg',
            imag3: 'https://res.cloudinary.com/da655b7xh/image/upload/v1729596829/ScreenShot134_h9jp3q.jpg',
            imag4: 'https://res.cloudinary.com/da655b7xh/image/upload/v1729596829/ScreenShot136_csvrje.jpg',
            imag5: 'https://res.cloudinary.com/da655b7xh/image/upload/v1729596828/ScreenShot137_lxkeal.jpg',
        },
        {
            titulo: 'Web para inmobiliaria',
            descripcion: 'Sitio para inmobiliaria de Mar del Plata conectado a la API de un CRM. Permite listar propiedades, filtrar resultados, paginar, guardar favoritos y ver detalles con carrusel de imagenes.',
            tecnologiasUtilizadas: 'Frontend: HTML, CSS, Material UI, React, Redux, JavaScript, Vercel. Backend: Node, MongoDB, Express, JWT, NodeMail, NPM, Google Cloud.',
            linkGithubFront: 'https://github.com/fmarcos38/Fornt-Inmobiliara-FMendive',
            linkGithubBack: 'https://github.com/fmarcos38/Back-inmobiliariaFMendive',
            linkURL: 'https://inmobiliaria-pagina-web.vercel.app/',
            imag1: inmoImg1,
            imag2: inmoImg2,
            imag3: inmoImg3,
        },
        {
            titulo: 'E-commerce',
            descripcion: 'Tienda online para Fábrica de Vermut. Login, dashboard administrativo, vistas/permisos cliente, empleado y administrador,  pasarela de pago con Mercado Pago, envio de emails entre otras funciones.',
            tecnologiasUtilizadas: 'HTML, CSS, Material UI, React, Redux, JavaScript, Node, MongoDB, Express, Mercado Pago, Cloudinary, JWT, NodeMail, Multer, NPM.',
            linkGithubFront: 'https://github.com/fmarcos38/Front-MarventoVermut',
            linkGithubBack: 'https://github.com/fmarcos38/Back-MarventoVermut',
            linkURL: 'https://www.marventovermut.com.ar/',
            imag1: marventoScreen003,
            imag2: marventoScreen004,
            imag3: marventoScreen005,
        },
    ],
};

export default function rootReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PROYECTS:
            return {
                ...state,
            }
        default:
            return state;
    }
}
